var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"y-full"},[_c('header-page'),_c('achievements'),_c('our-core',{attrs:{"id":"core"}}),_c('services'),_c('featured-projects',{attrs:{"id":"projects"}}),_c('our-process'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }